import { render, staticRenderFns } from "./AssignTaskListDialog.vue?vue&type=template&id=51e62eff"
import script from "./AssignTaskListDialog.vue?vue&type=script&lang=js"
export * from "./AssignTaskListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports